export default __webpack_public_path__ + "efe1da0a014b01d8810e7d6a80a1b83f.svg";